import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";

export default function* transactionFileDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_DELETE_REQUEST
    });

    yield call(Http.delete, `transaction-file/${action.payload?.transactionFile.id}`);

    const transactionFile = action.payload?.transactionFile.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_DELETE_SUCCESS,
      payload: {
        transactionFile: transactionFile
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-transaction-file-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_TRANSACTION_FILE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchTransactionFileDelete() {
  yield takeEvery(Constants.GLOBAL_TRANSACTION_FILE_DELETE_START, transactionFileDelete);
}
